import { NavItem, ParentNavItem } from "@shared/Frontend/components/navItems"

export const parseParentNavigationItem = (item: NavigationItemResponse): ParentNavItem => ({
  subNav: item.nestedItems?.map((item) => parseNavigationItem(item)),
  ...parseNavigationItem(item),
})

const parseNavigationItem = (item: NavigationItemResponse): NavItem => ({
  label: item.title,
  url: item.type === 'Wrapper' ? undefined : item.absolutePath,
  external: item.type === 'External',
})

export type NavigationResponse = {
  name: string
  visible: boolean
  slug: string
  locale: string
  localizationLinks: { [key: string]: string }
  items: Array<NavigationItemResponse>
}

type NavigationItemResponse = {
  title: string
  description?: string
  type: 'Internal' | 'External' | 'Wrapper'
  path?: string
  locale: string
  absolutePath: string
  externalPath?: string
  order: number
  nestedItems: Array<NavigationItemResponse>
}
